import React from 'react';
import {
  compose,
  withHandlers,
  withProps,
  lifecycle,
  withState,
  withPropsOnChange,
} from 'recompose';
import Paper from '@material-ui/core/Paper';
import withStyles from '@material-ui/core/styles/withStyles';
import { get, find, filter, trim } from 'lodash';
import queryString from 'query-string';
import { Grid, Table, TableHeaderRow, TableSelection } from '@devexpress/dx-react-grid-material-ui';
import { SelectionState, IntegratedSelection } from '@devexpress/dx-react-grid';
import {
  getReservation,
  getArchivedReservation,
  deleteReservationItem,
  alternativeReservationItem,
  reservationStatusNames,
  changeReservationStatus,
} from './_api';
import { connect } from 'react-redux';
import withLoader from '../app/withLoader';
import { withSnackbar } from 'notistack';
import MuiGrid from '@material-ui/core/Grid';
import { categories } from '../categories/_api';
import moment from 'moment';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import EditDialog from './editDialog';
import EditServicesDialog from './editServicesDialog';
import AddItemDialog from './addItemDialog';
import EditStatusDialog from './editStatusDialog';
import EditUserDialog from './editUserDialog';
import EditDiscountDialog from './editDiscountDialog';
import EditNoteDialog from './editNoteDialog';
import withCountPriceServeItem from './withCountPriceServeItem';
import Button from '@material-ui/core/Button';
import { printPdfDocument } from './_api';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link';
import QRCode from 'react-qr-code';
import { removeAccents } from '../../utils/index';

const styles = (theme) => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
    padding: 20,
  },
  paper: {
    padding: theme.spacing.unit,
    textAlign: 'left',
    margin: 15,
  },
  paper2: {
    padding: theme.spacing.unit,
  },
  div: {
    paddingBottom: 20,
  },
  gridItem: {
    marginBottom: 'auto',
    marginTop: 'auto',
  },
});

const getRowId = (row) => row.id;

const enhance = compose(
  withStyles(styles),
  withLoader,
  withSnackbar,
  connect(
    (state) => ({
      userAttributes: get(state, 'app.userAttributes', []),
      qrCodeSettings: get(state, 'app.qrCodeSettings', {}),
    }),
    null
  ),
  withProps(
    ({
      location: { search },
      match: {
        params: { id },
      },
    }) => {
      return {
        reservationId: id,
        parsed: queryString.parse(search),
      };
    }
  ),
  withState('item', 'setItem', null),
  withState('categories', 'setCategories', null),
  withState('editDialog', 'setEditDialog', {
    open: false,
    title: '',
    items: [],
    defaultItem: null,
  }),
  withState('editStatusDialog', 'setEditStatusDialog', { open: false }),
  withState('editUserDialog', 'setEditUserDialog', { open: false }),
  withState('editDiscountDialog', 'setEditDiscountDialog', { open: false }),
  withState('editNoteDialog', 'setEditNoteDialog', { open: false }),
  withState('addItemDialog', 'setAddItemDialog', { open: false }),
  withState('editServicesDialog', 'setEditServicesDialog', { open: false }),
  withState('statusNames', 'setStatusNames', []),
  withState('selection', 'setSelection', []),
  withHandlers({
    loadItem:
      ({ reservationId, setItem, setCategories, setStatusNames, parsed, setSelection }) =>
      async () => {
        setSelection([]);
        const archived = get(parsed, 'archived', 'false') === 'false' ? false : true;
        const [res, categoryItems, statusNames] = await Promise.all([
          archived ? getArchivedReservation(reservationId) : getReservation(reservationId),
          categories(),
          reservationStatusNames(),
        ]);
        if (res && categoryItems) {
          const editServices = [];
          setItem({ ...res, editServices });
          setCategories(get(categoryItems, 'items', []));
          setStatusNames(statusNames);
        }
      },
  }),
  lifecycle({
    async componentDidMount() {
      const { reservationId, loadItem, toggleLoader } = this.props;
      toggleLoader();
      await loadItem(reservationId);
      toggleLoader(false);
    },
  }),
  withCountPriceServeItem,
  withHandlers({
    onSubmit:
      ({ toggleLoader, enqueueSnackbar, history }) =>
      async (values) => {
        toggleLoader();
        /*const resp = await updateService(values);
      if (get(resp, 'success', false)) {
        enqueueSnackbar('Služba byla úspěšně změněna.', { variant: 'success' });
      } else {
        enqueueSnackbar('Službu se nepovedlo upravit.', { variant: 'error' });
      }
      toggleLoader(false);*/
        history.push('/services');
      },
    findSize: () => (attributes) => {
      const names = ['Velikost boty', 'Délka lyží', 'Sjezdové hole'];
      let size = '';
      names.map((item) => {
        const attr = find(attributes, { name: item });
        const value = get(attr, 'value', false);
        if (value) {
          size = value;
        }
        return {};
      });
      return size.replace(/\s+/g, '');
    },
    findBrand: () => (attributes) => {
      const names = ['Značka', 'Značka přilby', 'Značka SNB'];
      let size = '';
      names.map((item) => {
        const attr = find(attributes, { name: item });
        const value = get(attr, 'value', false);
        if (value) {
          size = value;
        }
        return {};
      });
      return size.replace(/\s+/g, '');
    },
    personAttributtes: () => (attributes) =>
      attributes.map((attr) => `${attr.name}: ${attr.value}`).join(', '),
    deleteItem:
      ({ reservationId, loadItem, toggleLoader }) =>
      async (id) => {
        toggleLoader();
        const resp = await deleteReservationItem(id);
        if (resp) {
          await loadItem(reservationId);
        }
        toggleLoader(false);
      },
    loadAlternativeItems:
      ({
        editDialog,
        setEditDialog,
        reservationId,
        categories,
        toggleLoader,
        serveItems,
        countDays,
      }) =>
      async (id) => {
        toggleLoader();
        const resp = await alternativeReservationItem(id);
        const title = get(find(categories, { id: get(resp, 'data.categoryId', '') }), 'name', '');
        setEditDialog({
          open: true,
          title,
          items: serveItems(
            {
              categoryId: get(resp, 'data.categoryId', ''),
              productsWithItems: [
                ...get(resp, 'data.productsWithItems', []),
                get(resp, 'data.originalItem', []),
              ],
            },
            '',
            countDays(resp.data.from, resp.data.to)
          ),
          defaultItem: get(resp, 'data.originalItem', []),
          reservationItemId: id,
          requestId: get(resp, 'data.requestServerUid'),
        });
        toggleLoader(false);
      },
  }),
  withProps(({ statusNames, classes, loadAlternativeItems, deleteItem }) => ({
    columns: [
      {
        name: 'status',
        title: 'Status',
        getCellValue: (row) => get(find(statusNames, { flagValue: row.status }), 'name'),
      },
      {
        name: 'category',
        title: 'Vybavení',
        getCellValue: (row) => (
          <span style={{ whiteSpace: 'normal' }}>
            {`${get(row, 'catLabel', '')}: `}
            {get(row, 'catValue')}
          </span>
        ),
      },
      {
        name: 'preis',
        title: 'Cena',
        getCellValue: (row) => `${get(row, 'price', '0')} Kč`,
      },
      {
        name: 'action',
        title: ' ',
        getCellValue: (row) => (
          <div className={classes.gridItem}>
            <IconButton
              aria-label="Edit"
              style={{ padding: 5 }}
              onClick={() => {
                loadAlternativeItems(row.id);
              }}
            >
              <EditIcon />
            </IconButton>
            <IconButton
              aria-label="Delete"
              style={{ padding: 5 }}
              onClick={() => {
                //eslint-disable-next-line
                if (confirm('Potvrdit odstranění')) {
                  deleteItem(row.id);
                }
              }}
            >
              <DeleteIcon />
            </IconButton>
          </div>
        ),
      },
    ],
  })),
  withHandlers({
    SelectionCol:
      () =>
      ({ ...restProps }) => {
        return <TableSelection.Cell {...restProps} />;
      },
    TableRow:
      ({ isMiniMode }) =>
      ({ row, ...restProps }) =>
        (
          <Table.Row
            {...restProps}
            style={{
              ...(isMiniMode ? { height: 'auto' } : {}),
            }}
          />
        ),
    TableHeaderRowCustom:
      ({ isMiniMode }) =>
      (props) =>
        (
          <Table.Row
            {...props}
            style={{
              ...(isMiniMode ? { height: 'auto' } : {}),
            }}
          />
        ),
    returnSelected:
      ({ reservationId, loadItem, toggleLoader }) =>
      async (selection) => {
        toggleLoader();
        const data = {
          statusWithItems: { 16: selection },
          sendEmail: false,
        };
        const resp = await changeReservationStatus(data);
        if (resp) {
          await loadItem(reservationId);
        }
        toggleLoader(false);
      },
  }),
  withHandlers({
    basicGrid:
      ({ TableRow, TableHeaderRowCustom, columns, selection, setSelection, SelectionCol }) =>
      (items) =>
        (
          <Paper>
            <div className="grid-no-clickable grid--custom">
              <Grid rows={items} columns={columns} getRowId={getRowId}>
                <SelectionState selection={selection} onSelectionChange={setSelection} />
                <IntegratedSelection />
                <Table rowComponent={TableRow} />
                <TableHeaderRow showSortingControls={false} rowComponent={TableHeaderRowCustom} />
                <TableSelection showSelectAll={false} cellComponent={SelectionCol} />
              </Grid>
            </div>
          </Paper>
        ),
  }),
  withPropsOnChange(['item', 'statusNames'], ({ item, statusNames }) => {
    let price = 0;
    let priceAfterDsc = 0;
    get(item, 'services', []).map((item1) => {
      price += item1.totalPrice;
      return {};
    });
    Object.keys(get(item, 'userWithItems', {})).map((res) => {
      get(item, `userWithItems.[${res}]`, {}).map((item1) => {
        price += get(item1, 'price', 0);
        return {};
      });
      return {};
    });
    priceAfterDsc = price;
    priceAfterDsc -= get(item, 'discountAmount', 0);
    priceAfterDsc = ((100.0 - get(item, 'discountPercentage', 0)) / 100) * priceAfterDsc;
    return {
      fields: [
        {
          id: 'user',
          label: 'Zákazník',
          value: `${get(item, 'user.forename', '')} ${get(item, 'user.surname', '')}`,
        },
        {
          id: 'date',
          label: 'Termín rezervace',
          value:
            get(item, 'from', false) && get(item, 'to', false)
              ? `${moment(item.from).format('DD.MM.YYYY, HH:mm')} - ${moment(item.to).format(
                  'DD.MM.YYYY, HH:mm'
                )}`
              : '',
        },
        {
          id: 'phone',
          label: 'Kontaktní telefon',
          value: get(item, 'user.phone', ''),
        },
        {
          id: 'id',
          label: 'Číslo rezervace',
          value: get(item, 'id', ''),
        },
        {
          id: 'status',
          label: 'Stav',
          value: get(find(statusNames, { flagValue: get(item, 'status') }), 'name'),
        },
        { id: 'note', label: 'Poznámka', value: get(item, 'note', ' ') },
        {
          id: 'discountPercentage',
          label: 'Sleva (%)',
          value: get(item, 'discountPercentage', 0),
        },
      ],
      priceSum: price,
      priceAfterDiscount: priceAfterDsc,
    };
  }),
  withHandlers({
    createQr:
      ({ item, qrCodeSettings }) =>
      (res) => {
        const person = get(item, `userWithItems[${res}][0].person`);
        const products = get(item, `userWithItems[${res}]`, []);
        const firstname = removeAccents(trim(get(person, 'forename')) || '');
        const surname = removeAccents(trim(get(person, 'surname')) || '');
        const name = `${firstname} ${surname}`;
        const ageVal = get(find(get(person, 'attributes', []), { name: 'Věk' }), 'value');
        const ageId = get(find(get(qrCodeSettings, 'ageArr', []), { val: ageVal }), 'id', '');
        const weightVal = get(find(get(person, 'attributes', []), { name: 'Hmotnost' }), 'value');
        const weightId = get(
          find(get(qrCodeSettings, 'weightArr', []), { val: weightVal }),
          'id',
          ''
        );
        const heightVal = get(find(get(person, 'attributes', []), { name: 'Výška' }), 'value');
        const heightId = get(
          find(
            get(qrCodeSettings, 'heightArr', []),
            (item) => item.min <= parseInt(heightVal, 10) && item.max >= parseInt(heightVal, 10)
          ),
          'id',
          ''
        );
        const shoe = find(products, (item) => get(item, 'product.categoryId') === 'LYZAKY');
        const shoeLengthVal = get(
          find(get(shoe, 'product.attributes', []), {
            name: 'Délka podrážky boty',
          }),
          'value'
        );
        const shoeLengthId = get(
          find(
            get(qrCodeSettings, 'shoeLengthArr', []),
            (item) =>
              item.min <= parseInt(shoeLengthVal, 10) && item.max >= parseInt(shoeLengthVal, 10)
          ),
          'id',
          ''
        );
        const skillVal = get(
          find(get(person, 'attributes', []), { name: 'Lyžařské zkušenosti' }),
          'value'
        );
        const skillId = get(find(get(qrCodeSettings, 'skillArr', []), { val: skillVal }), 'id', '');
        const shoeBrandVal = get(
          find(get(shoe, 'product.attributes', []), {
            name: 'Značka lyžáky',
          }),
          'value'
        );
        const shoeBrandId = get(
          find(get(qrCodeSettings, 'shoeBrandArr', []), { val: shoeBrandVal }),
          'id',
          '99'
        );
        const ski = find(products, (item) => get(item, 'product.categoryId') === 'LYZE');
        const skiBrandVal = get(
          find(get(ski, 'product.attributes', []), {
            name: 'Značka lyže sjezdové',
          }),
          'value'
        );
        const skiBrandId = get(
          find(get(qrCodeSettings, 'skiBrandArr', []), { val: skiBrandVal }),
          'id',
          '99'
        );
        const skiLengthVal = get(
          find(get(ski, 'product.attributes', []), {
            name: 'Délka lyží',
          }),
          'value',
          ''
        );
        const skiBindingBrandVal = get(
          find(get(ski, 'item.attributes', []), { name: 'Značka vázání' }),
          'value'
        );
        const skiBindingBrandId = get(
          find(get(qrCodeSettings, 'skiBindingBrandArr', []), { val: skiBindingBrandVal }),
          'id',
          99
        );
        const skiBindingTypeVal = get(
          find(get(ski, 'item.attributes', []), { name: 'Typ vázání' }),
          'value'
        );
        const skiBindingTypeId = get(
          find(get(qrCodeSettings, 'skiBindingTypeArr', []), {
            val: parseInt(skiBindingTypeVal, 10),
          }),
          'id',
          ''
        );
        console.log('---------------------------------------------------------');
        console.log('Jméno:', trim(name));
        console.log('Věk:', ageVal, ageId);
        console.log('Váha:', weightVal, weightId);
        console.log('Výška:', heightVal, heightId);
        console.log('Délka podrážky:', shoeLengthVal, shoeLengthId);
        console.log('Zkušenosti:', skillVal, skillId);
        console.log('Značka boty:', shoeBrandVal, shoeBrandId);
        console.log('Značka lyží:', skiBrandVal, skiBrandId);
        console.log('Délka lyží:', skiLengthVal);
        console.log('Značka vázání:', skiBindingBrandVal, skiBindingBrandId);
        console.log('Typ vázání:', skiBindingTypeVal, skiBindingTypeId);
        return shoe || ski
          ? `${trim(
              name
            )}/${ageId}/${weightId}/${heightId}/${shoeLengthId}/${skillId}/${shoeBrandId}/${skiBrandId}/${skiLengthVal}/${skiBindingBrandId}/${skiBindingTypeId}${get(
              qrCodeSettings,
              'suffix',
              ''
            )}`
          : null;
      },
  })
);

export default enhance(
  ({
    classes,
    item,
    fields,
    onSubmit,
    findSize,
    findBrand,
    priceSum,
    personAttributtes,
    basicGrid,
    returnSelected,
    selection,
    categories,
    deleteItem,
    editDialog,
    setEditDialog,
    loadAlternativeItems,
    setEditStatusDialog,
    editStatusDialog,
    setEditUserDialog,
    editUserDialog,
    statusNames,
    loadItem,
    toggleLoader,
    reservationId,
    priceAfterDiscount,
    setEditDiscountDialog,
    editDiscountDialog,
    editNoteDialog,
    setEditNoteDialog,
    addItemDialog,
    setAddItemDialog,
    editServicesDialog,
    setEditServicesDialog,
    createQr,
    enqueueSnackbar,
  }) => (
    <div className={classes.root}>
      <h3>Detail rezervace</h3>
      <Paper className={classes.paper}>
        <MuiGrid container={true} spacing={16}>
          {fields.map((field) => (
            <MuiGrid item={true} xs={12} md={4} lg={3} key={field.id}>
              <label className={classes.label}>{field.label}</label>
              <div>
                {field.id === 'status' ? (
                  field.value
                ) : field.id === 'user' ? (
                  <Link href={`/users/${get(item, 'user.id')}`}>{field.value}</Link>
                ) : (
                  field.value
                )}
                {field.id === 'status' ? (
                  <IconButton
                    aria-label="Edit"
                    style={{ padding: 5 }}
                    onClick={() => {
                      setEditStatusDialog({ open: true });
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                ) : null}
                {field.id === 'user' ? (
                  <IconButton
                    aria-label="Edit"
                    style={{ padding: 5 }}
                    onClick={() => {
                      setEditUserDialog({ open: true });
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                ) : null}
                {field.id === 'discountPercentage' ? (
                  <IconButton
                    aria-label="Edit"
                    style={{ padding: 5 }}
                    onClick={() => {
                      setEditDiscountDialog({ open: true });
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                ) : null}
                {field.id === 'note' ? (
                  <IconButton
                    aria-label="Edit"
                    style={{ padding: 5 }}
                    onClick={() => {
                      setEditNoteDialog({ open: true });
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                ) : null}
              </div>
            </MuiGrid>
          ))}
          <MuiGrid item={true} xs={12} md={12} lg={12}>
            <b>Rezervované vybavení</b>
            <Button
              size={'small'}
              variant="contained"
              color="primary"
              onClick={() => {
                //eslint-disable-next-line
                if (confirm('Opravdu vrátit vybrané vybavení?')) {
                  returnSelected(selection);
                }
              }}
              disabled={!selection.length}
              style={{ marginLeft: 15 }}
            >
              Vrátit vybrané
            </Button>
          </MuiGrid>
          <MuiGrid item={true} xs={12} md={12} lg={12}>
            <MuiGrid container={true} spacing={16} alignItems="stretch">
              {Object.keys(get(item, 'userWithItems', {})).map((res) => {
                const items = get(item, `userWithItems.[${res}]`, []).map((item) => {
                  const catLabel = get(
                    find(categories, {
                      id: get(item, 'product.categoryId', ''),
                    }),
                    'name',
                    ''
                  );
                  const catValue = [
                    get(item, 'item.serialNumber', ''),
                    findSize(item.product.attributes),
                    findBrand(item.product.attributes),
                  ]
                    .filter(Boolean)
                    .join('-');
                  return { ...item, catLabel, catValue };
                });
                return (
                  <MuiGrid item={true} xs={12} md={6} lg={4} key={res}>
                    <Paper className={classes.paper2}>
                      <MuiGrid container={true} spacing={16}>
                        <MuiGrid item={true} xs={12} md={12} lg={12}>
                          <label className={classes.label}>Osoba: </label>
                          {`${get(item, `userWithItems.[${res}][0].person.forename`, '')} ${get(
                            item,
                            `userWithItems.[${res}][0].person.surname`,
                            ''
                          )}`}
                        </MuiGrid>
                        <MuiGrid
                          item={true}
                          xs={12}
                          md={12}
                          lg={12}
                          style={{
                            marginBottom: 15,
                            marginTop: -5,
                            fontSize: 12,
                          }}
                        >
                          {personAttributtes(
                            get(item, `userWithItems.[${res}][0].person.attributes`, [])
                          )}
                        </MuiGrid>

                        <MuiGrid
                          item={true}
                          xs={12}
                          md={12}
                          lg={12}
                          style={{
                            marginBottom: 15,
                            marginTop: -5,
                            fontSize: 12,
                          }}
                        >
                          {basicGrid(items)}
                        </MuiGrid>
                      </MuiGrid>
                      {/* <MuiGrid item xs={4}>
                      <FormControl style={{ minWidth: 200 }}>
                        <InputLabel htmlFor={'addNewItem'}>Vyberte kategorii</InputLabel>
                        <Field
                          name={'addNewItem'}
                          component={Select2}
                          placeholder={'Vyberte kategorii'}
                          displayEmpty
                        >
                          {get(
                            find(typeActivity, {
                              id: get(data, 'type', false),
                            }),
                            'items',
                            [],
                          ).map(item2 => (
                            <MenuItem key={item2.name} value={item2.name}>
                              {item2.label}
                            </MenuItem>
                          ))}
                        </Field>
                      </FormControl>
                          </MuiGrid> */}
                      <MuiGrid item xs={4}>
                        <Button
                          variant="outlined"
                          onClick={() => {
                            setAddItemDialog({ open: true, personId: res });
                          }}
                        >
                          Přidat
                        </Button>
                      </MuiGrid>
                      <Divider />
                      <b>Servis</b>
                      <IconButton
                        aria-label="Edit"
                        style={{ padding: 5 }}
                        onClick={() => {
                          setEditServicesDialog({ open: true, personId: res });
                        }}
                      >
                        <EditIcon />
                      </IconButton>
                      {filter(
                        get(item, 'services', []),
                        (item) => item.personId === parseInt(res, 10)
                      ).map((item) => (
                        <MuiGrid item={true} xs={12} md={12} lg={12} key={item.serviceId}>
                          <label className={classes.label}>{get(item, 'name', '')}:</label>{' '}
                          {get(item, 'quantity', '')} x {get(item, 'unitPrice', '')} ={' '}
                          {get(item, 'totalPrice', '')} Kč
                        </MuiGrid>
                      ))}
                      {createQr(res) ? (
                        <div>
                          <QRCode value={createQr(res)} />
                          <div>{createQr(res)}</div>
                        </div>
                      ) : null}
                    </Paper>
                  </MuiGrid>
                );
              })}
            </MuiGrid>

            <MuiGrid item={true} xs={12} md={12} lg={12} style={{ margin: 20 }}>
              <label className={classes.label}>Sleva zadaná v korunách:</label>{' '}
              {get(item, 'discountAmount', 0)} Kč
            </MuiGrid>
            <MuiGrid item={true} xs={12} md={12} lg={12} style={{ margin: 20 }}>
              <label className={classes.label}>Sleva zadaná v procentech:</label>{' '}
              {get(item, 'discountPercentage', 0)} %
            </MuiGrid>
            <MuiGrid item={true} xs={12} md={12} lg={12} style={{ margin: 20 }}>
              <label className={classes.label}>Půjčovné před slevou:</label> {priceSum} Kč
            </MuiGrid>
            <MuiGrid item={true} xs={12} md={12} lg={12} style={{ margin: 20 }}>
              <label className={classes.label}>Půjčovné po slevě:</label> {priceAfterDiscount} Kč
            </MuiGrid>
            <MuiGrid item={true} xs={12} md={12} lg={12} style={{ margin: 20 }}>
              <Button
                variant="outlined"
                onClick={async (e) => {
                  e.stopPropagation();
                  toggleLoader();
                  const data = await printPdfDocument(reservationId, 'reservation');
                  const dataB64 = get(data, 'data');
                  if (dataB64) {
                    const linkSource = `data:application/pdf;base64,${dataB64}`;
                    var a = document.createElement('a');
                    a.href = linkSource;
                    a.download = `R-${get(item, 'user.surname')}-${get(item, 'id')}-${moment(
                      get(item, 'from')
                    ).format('YYMMDD')}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  } else {
                    enqueueSnackbar('Pdf dokument se nepodařilo vygenerovat.', {
                      variant: 'error',
                    });
                  }
                  toggleLoader(false);
                }}
              >
                Rezervace
              </Button>
              <Button
                variant="outlined"
                onClick={async (e) => {
                  e.stopPropagation();
                  toggleLoader();
                  const data = await printPdfDocument(reservationId, 'contract');
                  const dataB64 = get(data, 'data');
                  if (dataB64) {
                    const linkSource = `data:application/pdf;base64,${dataB64}`;
                    var a = document.createElement('a');
                    a.href = linkSource;
                    a.download = `S-${get(item, 'user.surname')}-${get(item, 'id', '')}-${moment(
                      get(item, 'from')
                    ).format('YYMMDD')}.pdf`;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                  } else {
                    enqueueSnackbar('Pdf dokument se nepodařilo vygenerovat.', {
                      variant: 'error',
                    });
                  }
                  toggleLoader(false);
                }}
              >
                Smlouva
              </Button>
            </MuiGrid>
          </MuiGrid>
        </MuiGrid>
      </Paper>
      {editDialog.open && (
        <EditDialog
          editDialog={editDialog}
          setEditDialog={setEditDialog}
          reservation={item}
          loadItem={loadItem}
        />
      )}
      {editStatusDialog.open && (
        <EditStatusDialog
          editStatusDialog={editStatusDialog}
          setEditStatusDialog={setEditStatusDialog}
          statusNames={statusNames}
          initialValues={{ status: item.status, sendEmail: true }}
          item={item}
          loadItem={loadItem}
        />
      )}
      {editUserDialog.open && (
        <EditUserDialog
          editUserDialog={editUserDialog}
          setEditUserDialog={setEditUserDialog}
          item={item}
          loadItem={loadItem}
        />
      )}
      {editDiscountDialog.open && (
        <EditDiscountDialog
          editDiscountDialog={editDiscountDialog}
          setEditDiscountDialog={setEditDiscountDialog}
          item={item}
          loadItem={loadItem}
          initialValues={{ discountPercentage: item.discountPercentage }}
        />
      )}
      {editNoteDialog.open && (
        <EditNoteDialog
          editNoteDialog={editNoteDialog}
          setEditNoteDialog={setEditNoteDialog}
          item={item}
          loadItem={loadItem}
          initialValues={{ note: item.note }}
        />
      )}
      {addItemDialog.open && (
        <AddItemDialog
          addItemDialog={addItemDialog}
          setAddItemDialog={setAddItemDialog}
          item={item}
          loadItem={loadItem}
        />
      )}
      {editServicesDialog.open && (
        <EditServicesDialog
          editServicesDialog={editServicesDialog}
          setEditServicesDialog={setEditServicesDialog}
          item={item}
          loadItem={loadItem}
        />
      )}
    </div>
  )
);



// WEBPACK FOOTER //
// ./src/modules/reservations/detail.js